import { render } from "./CarVideo.vue?vue&type=template&id=06eb060a"
import script from "./CarVideo.vue?vue&type=script&lang=js"
export * from "./CarVideo.vue?vue&type=script&lang=js"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__